var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { BackrsIcon } from '@backrs_ui/common-ui/src/atoms/BackrsIcon';
import { ASK_LUBAV_BUTTON_ENDPOINTS, } from '@backrs_ui/common-ui/src/models/nugget';
import { attemptToFixJson } from '@backrs_ui/common-ui/src/molecules/AskLubavButtons/askLubavApi.util';
import { PanelNugget } from '@backrs_ui/common-ui/src/molecules/Nugget/PanelNugget';
import { KeyboardArrowDown } from '@mui/icons-material';
import { Box, Typography, Button } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
export var getMarkdownComponents = function (contentSize) { return ({
    table: function (_a) {
        var props = __rest(_a, []);
        return _jsx("table", __assign({ style: tableStyle }, props));
    },
    th: function (_a) {
        var props = __rest(_a, []);
        return _jsx("th", __assign({ style: tableHeaderStyle }, props));
    },
    td: function (_a) {
        var props = __rest(_a, []);
        return _jsx("td", __assign({ style: tableCellStyle }, props));
    },
    a: function (_a) {
        var props = __rest(_a, []);
        return _jsx("a", __assign({ style: linkStyle, target: "_blank", rel: "noopener noreferrer" }, props));
    },
    ul: function (_a) {
        var props = __rest(_a, []);
        return _jsx("ul", __assign({ style: listStyle(contentSize) }, props));
    },
    ol: function (_a) {
        var props = __rest(_a, []);
        return _jsx("ol", __assign({ style: listStyle(contentSize) }, props));
    },
    p: function (_a) {
        var props = __rest(_a, []);
        return _jsx("p", __assign({ style: paragraphStyle(contentSize) }, props));
    },
    li: function (_a) {
        var props = __rest(_a, []);
        return _jsx("li", __assign({ style: listItemStyle(contentSize) }, props));
    },
}); };
var defaultLubavResponse = {
    introductory_paragraph: '',
    headers: [],
    bodies: [],
    summary: '',
};
export var AskLubavResponse = function (_a) {
    var _b, _c;
    var response = _a.response, tier = _a.tier, apiKeyAction = _a.apiKeyAction, containerSx = _a.containerSx, _d = _a.contentSize, contentSize = _d === void 0 ? 'LARGE' : _d, _e = _a.collapsedByDefault, collapsedByDefault = _e === void 0 ? false : _e;
    var _f = useState(defaultLubavResponse), parsedResponse = _f[0], setParsedResponse = _f[1];
    var _g = useState(undefined), parsedResponseWithNuggets = _g[0], setParsedResponseWithNuggets = _g[1];
    var _h = useState([]), openSections = _h[0], setOpenSections = _h[1];
    var _j = useState(0), numSections = _j[0], setNumSections = _j[1];
    useEffect(function () {
        if (parsedResponse.headers) {
            if (parsedResponse.headers.length !== numSections) {
                setNumSections(parsedResponse.headers.length);
                setOpenSections(parsedResponse.headers.map(function (header) {
                    if ((apiKeyAction === null || apiKeyAction === void 0 ? void 0 : apiKeyAction.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_ROLES_BY_TRACK) {
                        return tier ? header === tier : false;
                    }
                    return !collapsedByDefault;
                }));
            }
        }
    }, [parsedResponse.headers, apiKeyAction, tier, collapsedByDefault, numSections]);
    var toggleSection = function (index) {
        setOpenSections(function (prev) {
            var newOpenSections = __spreadArray([], prev, true);
            newOpenSections[index] = !newOpenSections[index];
            if (collapsedByDefault) {
                newOpenSections.forEach(function (_, i) {
                    if (i !== index) {
                        newOpenSections[i] = false;
                    }
                });
            }
            return newOpenSections;
        });
    };
    useEffect(function () {
        if (response) {
            var fixedJson = attemptToFixJson(response, defaultLubavResponse);
            if (fixedJson) {
                try {
                    setParsedResponse(JSON.parse(fixedJson));
                }
                catch (error) {
                    console.error('Failed to parse JSON after fixing:', error);
                    setParsedResponse(defaultLubavResponse);
                }
            }
            try {
                var parsed = JSON.parse(response);
                setParsedResponseWithNuggets(parsed);
            }
            catch (_a) {
                setParsedResponseWithNuggets(undefined);
            }
        }
    }, [response]);
    if (!parsedResponse) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(Box, { sx: __assign(__assign({}, containerStyle), containerSx), children: [_jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], components: getMarkdownComponents(contentSize), children: parsedResponse.introductory_paragraph || '' }), ((_b = parsedResponse.headers) === null || _b === void 0 ? void 0 : _b.map(function (header, index) {
                var _a;
                var body = ((_a = parsedResponse.bodies) === null || _a === void 0 ? void 0 : _a[index]) || '';
                return (_jsxs(Box, { sx: { mt: '0.2em' }, children: [header && (_jsxs(Typography, { onClick: function () { return toggleSection(index); }, sx: typographyStyle(contentSize), children: [header, _jsx(KeyboardArrowDown, { sx: getArrowIconStyle(openSections[index]) })] })), openSections[index] && (_jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], components: getMarkdownComponents(contentSize), children: body }))] }, index));
            })) || [], ((_c = parsedResponseWithNuggets === null || parsedResponseWithNuggets === void 0 ? void 0 : parsedResponseWithNuggets.nuggets) === null || _c === void 0 ? void 0 : _c.internships) && (_jsx(Box, { sx: internshipContainerStyle, children: parsedResponseWithNuggets.nuggets.internships.map(function (internship, index) { return (_jsx(Box, { sx: { mb: 4 }, children: _jsx(PanelNugget, { title: internship.metadata.role_title, variant: {
                            type: 'internship',
                            internshipInfo: internship.metadata,
                        }, body: internship.metadata.ai_description, subText: internship.relevance, size: "SMALL" }) }, index)); }) })), (apiKeyAction === null || apiKeyAction === void 0 ? void 0 : apiKeyAction.onClick) && apiKeyAction.actionButtonText && (_jsxs(Button, { variant: "contained", onClick: apiKeyAction.onClick, sx: markersOfSuccessButtonStyle, children: [_jsx(Typography, { sx: markersOfSuccessTextStyle, children: apiKeyAction.actionButtonText }), _jsx(BackrsIcon, { name: "IconArrowOpenRight", alt: "IconArrowRight", style: markersOfSuccessIconStyle })] }))] }));
};
var containerStyle = {
    backgroundColor: appColors.color.blue10,
    padding: '.5rem',
    paddingLeft: '24px',
    paddingRight: '24px',
    borderRadius: '9px',
    boxSizing: 'border-box',
};
var tableStyle = {
    borderCollapse: 'separate',
    borderSpacing: 0,
    width: '100%',
    borderTop: "2px solid ".concat(appColors.neutral.black),
    borderBottom: "2px solid ".concat(appColors.neutral.black),
    marginTop: '22px',
};
var tableHeaderStyle = {
    border: 'none',
    padding: '4px 8px',
    color: appColors.neutral.black,
    borderBottom: "2px solid ".concat(appColors.neutral.black),
    textAlign: 'left',
};
var tableCellStyle = {
    border: 'none',
    padding: '4px 8px',
    whiteSpace: 'nowrap',
    width: 'fit-content',
};
var linkStyle = {
    color: appColors.color.blue1,
    fontWeight: 'bold',
};
var typographyStyle = function (contentSize) {
    return function (_a) {
        var typography = _a.typography;
        return (__assign(__assign({}, typography[contentSize === 'LARGE' ? 'text-lg-bold' : 'text-md-bold']), { cursor: 'pointer', display: 'flex', alignItems: 'center' }));
    };
};
var markersOfSuccessButtonStyle = {
    backgroundColor: appColors.color.blue1,
    borderRadius: '9px',
    cursor: 'pointer',
    px: '16px',
    py: '8px',
    '&:hover': {
        backgroundColor: appColors.color.blue2,
        boxShadow: 'none',
    },
    boxShadow: 'none',
};
var markersOfSuccessTextStyle = {
    fontSize: '16px',
    textTransform: 'none',
    fontWeight: 700,
    color: '#FFFFFF',
};
var markersOfSuccessIconStyle = {
    width: '16px',
    height: '16px',
    marginLeft: '12px',
    verticalAlign: 'middle',
};
var getArrowIconStyle = function (isOpen) {
    return ({
        transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
        transition: 'transform 0.2s ease-in-out',
        marginLeft: '4px',
    });
};
var internshipContainerStyle = {
    backgroundColor: '#FFF',
    borderRadius: '9px',
    padding: '16px',
};
var paragraphStyle = function (contentSize) { return ({
    fontSize: contentSize === 'LARGE' ? '16px' : '14px',
}); };
var listItemStyle = function (contentSize) { return ({
    fontSize: contentSize === 'LARGE' ? '16px' : '14px',
    marginBottom: '0.5em',
}); };
var listStyle = function (contentSize) { return ({
    paddingLeft: contentSize === 'SMALL' ? '1.5rem' : undefined,
    marginBottom: '0.5em',
}); };
